import { Dispatch } from 'react';
import { Action, Reducer } from 'redux';
import InstanceClient from '../services/InstanceClient';
import StatusCode from '../util/StatusCode';
import { MasterFlowSyncConsumer } from '../models/MasterFlowSyncConsumer';
import { RequestState } from '../models/RequestState';


enum ConsumerActionType {
    GET_CONSUMERS = 'GET_CONSUMERS',
}

export interface ConsumerState {
    consumers: RequestState<MasterFlowSyncConsumer[]>
};

interface Consumers_GetConsumers extends Action<ConsumerActionType> {
    type: ConsumerActionType.GET_CONSUMERS,
    consumers: RequestState<MasterFlowSyncConsumer[]>
};

type ConsumerAction = Consumers_GetConsumers;


export const GetConsumers = () => (dispatch: Dispatch<Consumers_GetConsumers>) => {

    dispatch({
        type: ConsumerActionType.GET_CONSUMERS,
        consumers: { code: StatusCode.PENDING }
    });

    InstanceClient.get<MasterFlowSyncConsumer[]>('/api/core/consumer')
        .then(res => dispatch({
            type: ConsumerActionType.GET_CONSUMERS,
            consumers: { code: StatusCode.COMPLETE, data: res.data },
        }))
        .catch(err => dispatch({
            type: ConsumerActionType.GET_CONSUMERS,
            consumers: { code: StatusCode.ERROR, error: err },
        }));
}


const initialState: ConsumerState = {
    consumers: { code: StatusCode.NONE },
};

export const reducer: Reducer<ConsumerState, ConsumerAction> = (state, action) => {
    state = state || initialState;

    switch (action.type) {
        case ConsumerActionType.GET_CONSUMERS:
            return {
                ...state,
                consumers: action.consumers,
            };
        default:
            return state;
    }
}
